import Select, { components } from "react-select";
import PropTypes from "prop-types";

// 🔹 Custom Option with Checkbox
const Option = (props) => {
    const { isSelected, label, selectProps, data } = props;

    const isAll = data.value === "all";
    const allItems = selectProps.options.filter((opt) => opt.value !== "all");

    const allSelected = selectProps.value.length === allItems.length;

    return (
        <components.Option {...props}>
            <input
                type="checkbox"
                checked={isAll ? allSelected : isSelected}
                onChange={() => null}
                style={{ marginRight: 8 }}
            />
            {label}
        </components.Option>
    );
};

// ✅ PropTypes for Option
Option.propTypes = {
    isSelected: PropTypes.bool,
    label: PropTypes.node,
    data: PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.node,
    }).isRequired,
    selectProps: PropTypes.shape({
        value: PropTypes.array,
        options: PropTypes.array,
    }).isRequired,
};

// 🔹 Main Component
const MultiSelectWithCheckbox = ({ options, value, onChange }) => {
    const handleChange = (selectedOptions) => {
        if (!selectedOptions) {
            onChange([]);
            return;
        }

        const isSelectAllClicked = selectedOptions.some((opt) => opt.value === "all");

        const allItems = options.filter((opt) => opt.value !== "all");

        if (isSelectAllClicked) {
            const isAllAlreadySelected = value?.length === allItems?.length;

            // 🔁 Toggle
            onChange(isAllAlreadySelected ? [] : allItems);
        } else {
            onChange(selectedOptions);
        }
    };

    return (
        <Select
            className="dialogue-dropdown as-input-field"
            name={"comp_product_code"}
            placeholder={""}
            options={[{ value: "all", label: "Select All" }, ...options]}
            value={value}
            onChange={handleChange}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{ Option }}
        />
    );
};

// ✅ PropTypes for main component
MultiSelectWithCheckbox.propTypes = {
    options: PropTypes.array,
    value: PropTypes.array,
    onChange: PropTypes.func,
};

export default MultiSelectWithCheckbox;
